var index = {
    data() {
        return {
            key: '',
            appId: '',
            categoryCode: '',
            paystatus: '',
            orderstatus: '',
            status: '',
            sort: '',
            pageindex: 0,
            pagesize: 20,
            loading: false,
            loaded: false,
            list: [],
            total: 0,
            error: ''
        }
    },
    fetch() {

    },
    reload() {
        this.list = [];
        this.pageindex = 0;
        this.select();
    },
    select() {
        this.loading = true;
        this.$api.order.select({
            key: this.key,
            appId: this.appId,
            categoryCode: this.categoryCode,
            paystatus: this.paystatus,
            orderstatus: this.orderstatus,
            status: this.status,
            sort: this.sort,
            pageIndex: this.pageindex + 1,
            pageSize: this.pagesize
        }).then((res) => {
            this.loading = false;
            if (res.R) {
                this.pageindex++;
                var rows = res.data.rows;
                this.total = res.data.total;
                this.list.push(...rows);
                this.loaded = rows.length != this.pagesize;
            } else {
                this.error = res.msg
                this.loaded = true;
            }
        })

    }
}



export default index;